"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var clsx_1 = __importDefault(require("clsx"));
var LIST = "flex flex-col py-2";
var LIST_ITEM = "flex flex-row py-1 mb-1 border-b border-gray-200 text-gray-800 text-sm";
var LIST_ITEM_LABEL = "flex truncate my-auto";
var ICON = "flex text-md text-blue-600 my-auto mr-2";
var List = function (_a) {
    var items = _a.items, className = _a.className;
    return ((0, jsx_runtime_1.jsx)("ul", __assign({ className: (0, clsx_1.default)(LIST, className) }, { children: items.map(function (item) { return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: LIST_ITEM }, { children: [item.icon ? ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: item.icon, className: ICON }, void 0)) : null, (0, jsx_runtime_1.jsx)("span", __assign({ className: LIST_ITEM_LABEL }, { children: item.label }), void 0), item.accessory ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex ml-auto" }, { children: item.accessory() }), void 0)) : null] }), item.id)); }) }), void 0));
};
exports.List = List;
